export const siteInfo = {
  name: '爆瓜福利',
  fullName: '爆瓜福利 · 吃瓜娱乐福利站',
  slogan: '吃瓜不吃亏，福利轻松领',
  intro: '把散落在各个角落的福利活动、抽奖玩法与任务奖励规则讲清楚，让你花三分钟就能看懂怎么参与、怎么领奖。',
  email: 'hello@baogua-fuli.cn',
  hours: '周一至周日 09:00 - 22:00',
  updateNote: '规则与奖励以活动页面实时展示为准',
};

export const navLinks = [
  { label: '首页', path: '/' },
  { label: '福利活动', path: '/activities' },
  { label: '玩法与规则', path: '/rules' },
  { label: '常见问题', path: '/faq' },
  { label: '关于我们', path: '/about' },
];

export const stats = [
  { value: '286', suffix: '个', label: '在架福利活动', icon: 'ri-gift-2-line' },
  { value: '42.7', suffix: '万', label: '累计参与人次', icon: 'ri-user-heart-line' },
  { value: '96', suffix: '%', label: '奖励按时发放率', icon: 'ri-timer-flash-line' },
  { value: '3.5', suffix: '分钟', label: '平均看懂规则用时', icon: 'ri-book-open-line' },
];

export const categories = [
  { id: 'daily', name: '每日签到', desc: '每天点一下，积少成多换好礼', icon: 'ri-calendar-check-line', count: 48, color: 'primary' },
  { id: 'invite', name: '邀请好友', desc: '拉上好友一起瓜分奖励池', icon: 'ri-group-line', count: 36, color: 'secondary' },
  { id: 'engage', name: '内容互动', desc: '评论、点赞、投稿都算任务', icon: 'ri-chat-smile-2-line', count: 62, color: 'accent' },
  { id: 'lucky', name: '限时抽奖', desc: '整点开奖，奖品看得见', icon: 'ri-trophy-line', count: 41, color: 'primary' },
  { id: 'newbie', name: '新人大礼', desc: '首次参与就能领的见面礼', icon: 'ri-emotion-happy-line', count: 27, color: 'secondary' },
  { id: 'back', name: '返场福利', desc: '错过还能补领的经典活动', icon: 'ri-history-line', count: 19, color: 'accent' },
];

export const steps = [
  {
    step: '01',
    title: '挑一个活动',
    desc: '在福利活动中心按分类筛选，找到适合自己时间与精力的玩法。',
    icon: 'ri-search-eye-line',
  },
  {
    step: '02',
    title: '看清奖励规则',
    desc: '活动详情页会写清楚任务要求、奖励内容与完成时限，避免白忙一场。',
    icon: 'ri-file-list-3-line',
  },
  {
    step: '03',
    title: '完成任务攒资格',
    desc: '签到、互动、邀请等任务完成后，会累积抽奖次数或兑换资格。',
    icon: 'ri-checkbox-multiple-line',
  },
  {
    step: '04',
    title: '领取与查看到账',
    desc: '在「我的福利」里确认领取，奖励一般会在 24 小时内发放到账。',
    icon: 'ri-hand-coin-line',
  },
];

export const taskRules = [
  { name: '每日签到', require: '每天进入活动页点击签到', reward: '5 - 20 瓜豆', limit: '每日 1 次', time: '即时到账' },
  { name: '观看内容', require: '完整浏览指定内容满 30 秒', reward: '3 瓜豆 / 条', limit: '每日最多 8 条', time: '即时到账' },
  { name: '留言互动', require: '发布带有效内容的评论', reward: '8 瓜豆 / 条', limit: '每日最多 5 条', time: '审核后 2 小时' },
  { name: '邀请好友', require: '好友通过专属链接完成首次签到', reward: '50 瓜豆 / 人', limit: '每日最多 10 人', time: '次日统一结算' },
  { name: '内容投稿', require: '投稿被采纳并展示', reward: '200 - 800 瓜豆', limit: '不限次数', time: '采纳后 24 小时' },
  { name: '连续签到', require: '连续签到满 7 天', reward: '额外 100 瓜豆', limit: '每周期 1 次', time: '第 7 天发放' },
];

export const prizePool = [
  { label: '瓜豆 x20', level: 'common' },
  { label: '瓜豆 x50', level: 'common' },
  { label: '免单券', level: 'rare' },
  { label: '瓜豆 x100', level: 'rare' },
  { label: '限定周边', level: 'epic' },
  { label: '瓜豆 x10', level: 'common' },
  { label: '体验会员', level: 'rare' },
  { label: '谢谢参与', level: 'none' },
];

export const testimonials = [
  {
    name: '林小满',
    role: '连续签到 68 天',
    avatar: 'https://readdy.ai/api/search-image?query=Friendly%20portrait%20of%20a%20young%20woman%20smiling%20warmly%2C%20soft%20neutral%20studio%20background%2C%20natural%20lighting%2C%20clean%20professional%20headshot&width=200&height=200&seq=avatar-a1&orientation=squarish',
    text: '以前看到福利活动一堆规则就头大，这里把任务和奖励写得明明白白，我照着做一个月换了三个周边。',
  },
  {
    name: '阿哲',
    role: '邀请好友达人',
    avatar: 'https://readdy.ai/api/search-image?query=Cheerful%20portrait%20of%20a%20young%20man%20laughing%2C%20warm%20beige%20studio%20background%2C%20soft%20natural%20lighting%2C%20clean%20professional%20headshot&width=200&height=200&seq=avatar-b2&orientation=squarish',
    text: '邀请奖励的结算时间写得很清楚，不用天天刷新等，省心。奖励到账也从来没拖过。',
  },
  {
    name: '周周不摆烂',
    role: '抽奖常客',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20relaxed%20young%20woman%20with%20a%20soft%20smile%2C%20warm%20cream%20studio%20background%2C%20gentle%20natural%20lighting%2C%20clean%20headshot&width=200&height=200&seq=avatar-c3&orientation=squarish',
    text: '抽奖概率和奖品数量都摆在明面上，心里有底就不会觉得是套路，玩起来反而更开心。',
  },
];

export const contactInfo = [
  { label: '合作与反馈邮箱', value: 'hello@baogua-fuli.cn', icon: 'ri-mail-send-line' },
  { label: '在线服务时间', value: '周一至周日 09:00 - 22:00', icon: 'ri-time-line' },
  { label: '内容纠错', value: '发现规则写错？发邮件告诉我们', icon: 'ri-error-warning-line' },
];

export const footerGroups = [
  {
    title: '逛一逛',
    links: [
      { label: '首页', path: '/' },
      { label: '福利活动', path: '/activities' },
      { label: '玩法与规则', path: '/rules' },
    ],
  },
  {
    title: '了解我们',
    links: [
      { label: '关于我们', path: '/about' },
      { label: '常见问题', path: '/faq' },
      { label: '活动提醒订阅', path: '/#subscribe' },
    ],
  },
  {
    title: '规则说明',
    links: [
      { label: '奖励发放说明', path: '/rules#reward' },
      { label: '抽奖概率公示', path: '/rules#lucky' },
      { label: '领取流程', path: '/rules#claim' },
    ],
  },
];